import { OrganizationBusinessRepository } from '@/businessRepository/organizationBusinessRepository';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 取引情報をシステムから取得する
 */
export class BulkGetBusinessUseCase {
  /**
   * businessIdにマッチする取引を取得する
   * @param repository - 取引情報の永続化の責務を負うクラス
   * @param businessIds - 取引ID
   * @returns 取引情報
   */
  async Execute(repository: OrganizationBusinessRepository, businessIds: string[]): Promise<INetworkResult<IBusiness[], Error>> {
    try {
      const res = await repository.balkGet(businessIds);
      if (res.status.type === 'success') {
        const business: IBusiness[] = simpleCopy(res.status.data);
        return {
          status: {
            type: 'success',
            data: business,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: Error('取得に失敗しました'),
          },
        };
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
